import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchLogin } from "./loginAPI";
import swal from 'sweetalert';
export interface LoginState {
  login: any;
  status: "idle" | "loading" | "failed" | "success";
  accessToken : string;
  isAdmin: Boolean;
}

const initialState: LoginState = {
  login: [],
  status: "idle",
  accessToken : '',
  isAdmin: false
};

export const GetLogin = createAsyncThunk(
  "logIn/fetchLogin",
  async (data: any) => {
    const response = await fetchLogin(data);
    return response;
  }
);

export const loginSlice = createSlice({
  name: "logIn",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetLogin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetLogin.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetLogin.fulfilled, (state, action) => {
        //if(action.payload.status == 200) {
          state.status = "success";
          state.login=action.payload.data;
          state.accessToken = action.payload.data.accessToken;
          state.isAdmin = action.payload.isAdmin
          localStorage.setItem('userDetails', JSON.stringify(action.payload.data));
        // }else {
        //   state.status = "failed"
        // }
       
      });
  },
});

export const {} = loginSlice.actions;

export const selectLogin = (state: RootState) => {
  return state.logIn.login;
};
export const selectLoginStatus = (state: RootState) => {
  return state.logIn.status;
};



export default loginSlice.reducer;
